<template>
  <div @click="handleClick" class="time-slider-item">
    <a @click="handleClick">{{ time }}</a>
    <div class="border-bottom" :style="markerStyle"></div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import BookingMixins from '../../mixins/booking-mixins';

export default {
  mixins: [BookingMixins],

  props: {
    hour: Number,
  },

  computed: {
    ...mapState([
      'bookings',
    ]),

    time() {
      const p = (this.hour < 12 || this.hour === 0) ? 'am' : 'pm';
      let t;
      if (this.hour === 0) {
        t = 12;
      } else {
        t = (this.hour <= 12) ? this.hour : this.hour - 12;
      }

      return `${t}${p}`;
    },

    bookingsAtHour() {
      return this.getBookingsByHour(this.bookings, this.hour);
    },

    bookingAtHour() {
      return this.bookingsAtHour[0];
    },

    startDateTime() {
      if (!this.bookingAtHour) {
        return null;
      }

      return new Date(this.bookingAtHour.start_date);
    },

    endDateTime() {
      if (!this.bookingAtHour) {
        return null;
      }

      return new Date(this.bookingAtHour.end_date);
    },

    markerStart() {
      if (this.startDateTime.getHours() < this.hour) {
        return 0;
      }
      const minutes = this.startDateTime.getMinutes();
      return Math.round((minutes / 60) * 100);
    },

    markerEnd() {
      if (this.bookingsAtHour.length === 2) {
        return 100;
      } else if (this.endDateTime.getHours() === this.hour) {
        const minutes = this.endDateTime.getMinutes();
        return Math.round((minutes / 60) * 100);
      }

      return 100;
    },

    markerStyle() {
      if (!this.bookingAtHour) {
        return { display: 'none' };
      }

      const width = this.markerEnd - this.markerStart;
      let margin = 0;

      if (this.markerStart > 0) {
        margin = this.markerStart;
      }

      return {
        width: `${width}%`,
        'margin-left': `${margin}%`,
      };
    },
  },

  methods: {
    ...mapMutations(['setHourToDisplay']),
    handleClick() {
      this.setHourToDisplay(this.hour);
    },
  },
};
</script>

<style lang="scss" scoped>
  a {
    color: #fff;
  }

  .border-bottom {
    margin-top: 10px;

    @media only screen and (max-width: 720px) {
      margin-top: 2px;
    }

    border-top: 4px solid #7ED321;
  }
</style>




// WEBPACK FOOTER //
// src/components/TimeSlider/TimeSliderItem.vue